import { render, staticRenderFns } from "./ContactHistoryTable.vue?vue&type=template&id=13fbe27c&scoped=true&"
import script from "./ContactHistoryTable.vue?vue&type=script&lang=js&"
export * from "./ContactHistoryTable.vue?vue&type=script&lang=js&"
import style0 from "./ContactHistoryTable.vue?vue&type=style&index=0&id=13fbe27c&lang=scss&scoped=true&"
import style1 from "./ContactHistoryTable.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13fbe27c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VChip,VCol,VDialog,VIcon,VList,VListItem,VMenu,VRow,VSimpleTable,VTextField,VTooltip})
